/**
 * Shared column widths for "Rooms & booths" and "Equipment" tables on location settings
 * so Name / Type|Portability / Capacity|Assigned room / Status align across sections.
 */
export const LOCATION_RESOURCE_TABLE_COL_WIDTHS = {
  name: 160,
  typePortability: 120,
  capacityAssignedRoom: 140,
  status: 180,
  actions: 96,
} as const;

export const locationResourceTableStyle = {
  tableLayout: 'fixed' as const,
  width: '100%',
};
